import { render, staticRenderFns } from "./table_test.vue?vue&type=template&id=2a23c92e"
import script from "./table_test.vue?vue&type=script&lang=js"
export * from "./table_test.vue?vue&type=script&lang=js"
import style0 from "./table_test.vue?vue&type=style&index=0&id=2a23c92e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports